define('TescoMobile_Checkout/js/model/create-callback-url',['mage/url'], function (urlBuilder) {
  'use strict';

  urlBuilder.build(window.BASE_URL);
  const createUrl = (baseUrl, successPath, failurePath) => {
    const url = new URL(baseUrl);
    url.searchParams.set('successURL', urlBuilder.build(successPath));
    url.searchParams.set('failureURL', urlBuilder.build(failurePath));
    return url.toString();
  };
  return {
    cca: baseUrl => createUrl(baseUrl, 'checkout/cca/success', 'checkout/cca/fail'),
    payment: baseUrl => createUrl(baseUrl, 'checkout/cvv/success', 'checkout/cvv/fail')
  };
});

